import Footer from './src/Footer';

export default Footer;
